'use client'

import {
  FlexContainer,
  CategoryTitle,
  Size,
  FontWeight,
  DesktopOnly,
  LineSeparator,
  MobileOnly,
  HorizontalCarousel,
  Container
} from '@news12/storybook-news'

import React, { Fragment } from 'react'

import { StoryPreview } from '../../types'
import MoreStoriesCard from './MoreStoriesCard'

import { useTheme } from 'styled-components'

export type MoreStoriesProps = {
  stories: StoryPreview[]
}

const MoreStories = ({ stories }: MoreStoriesProps) => {
  const theme = useTheme()

  return (
    <FlexContainer direction='column' gap={{ default: '1rem', lg: '1.5rem' }}>
      <CategoryTitle withMarker size={Size.Tiny} fontWeight={FontWeight.Semibold} tag='h3'>
        More Stories
      </CategoryTitle>
      <DesktopOnly breakpoint={theme.breakpoints.lg}>
        <FlexContainer direction='column' gap='1rem'>
          {stories.map((story, index) => (
            <Fragment key={story.id}>
              {Boolean(index) && <LineSeparator margin='0' />}
              <MoreStoriesCard orderNumber={index + 1} {...story} />
            </Fragment>
          ))}
        </FlexContainer>
      </DesktopOnly>
      <MobileOnly breakpoint={theme.breakpoints.lg}>
        <Container padding='0' margin='0 -1rem'>
          <HorizontalCarousel showArrows={false}>
            {stories.map((story, index) => (
              <MoreStoriesCard key={story.id} orderNumber={index + 1} {...story} />
            ))}
          </HorizontalCarousel>
        </Container>
      </MobileOnly>
    </FlexContainer>
  )
}

export default MoreStories
